"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.authOptions = void 0;
var credentials_1 = __importDefault(require("next-auth/providers/credentials"));
var authHelpers_1 = require("./authHelpers");
var authOptions = function (authMutation) {
    return {
        providers: [
            (0, credentials_1["default"])({
                name: "Credentials",
                // @ts-ignore
                authorize: function (credentials) {
                    return __awaiter(this, void 0, void 0, function () {
                        var response;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, (0, authHelpers_1.authorise)(credentials.email, credentials.password, authMutation)];
                                case 1:
                                    response = _a.sent();
                                    if (response.errors) {
                                        throw new Error(response.errors);
                                    }
                                    return [2 /*return*/, response];
                            }
                        });
                    });
                }
            }),
        ],
        callbacks: {
            jwt: function (_a) {
                var token = _a.token, user = _a.user;
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_b) {
                        if (user) {
                            // user is only set on JWT creation
                            token.accessToken = user.accessToken;
                            token.refreshToken = user.refreshToken;
                            // Clear out tokens from user object
                            user.accessToken = "";
                            user.refreshToken = "";
                        }
                        if (!token.tokenExp) {
                            // Expiry isn't retrieved on login, so we need to verify the token to get it
                            (0, authHelpers_1.verifyToken)(token);
                            // (should probably verify on session resume)
                        }
                        if (Date.now() < token.tokenExp * 1000) {
                            (0, authHelpers_1.refreshToken)(token);
                        }
                        return [2 /*return*/, token];
                    });
                });
            },
            session: function (_a) {
                var session = _a.session, token = _a.token, user = _a.user;
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_b) {
                        session.accessToken = token.accessToken;
                        return [2 /*return*/, session];
                    });
                });
            }
        },
        pages: {
            signIn: "/login"
        }
    };
};
exports.authOptions = authOptions;
